let apiBaseUrl = "";
let socketUrl = "";
const aiBaseUrl = "";
let siteUrl = "";
const appStage = process.env.REACT_APP_STAGE;
let cloudFrontUrl = "";
let pfrApiUrl = "";

if (appStage === "local") {
  siteUrl = "http://localhost:3030";
  apiBaseUrl = "http://10.25.27.69:8000/api/v2/";
  socketUrl = "https://socket.insiderodeo.com:6672/";
  cloudFrontUrl = "https://dk6gd0p0lw8ui.cloudfront.net/assets/si/";
  pfrApiUrl = "https://pfr-api.stage.tetonridge.io/api/v1/";
} else if (appStage === "dev") {
  siteUrl = "https://rodeopicks-v2.dreamztesting.com";
  apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v2/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
  pfrApiUrl = "https://pfr-api.stage.tetonridge.io/api/v1/";
} else if (appStage === "prod") {
  siteUrl = "https://www.insiderodeo.com";
  apiBaseUrl = "https://backendrodeo.insiderodeo.com/api/v1/";
  socketUrl = "https://socket.insiderodeo.com:6672/";
  cloudFrontUrl = "https://d2mkr7tc1e0pje.cloudfront.net/assets/share_image/";
  pfrApiUrl = "https://controlcenter.profantasyrodeo.com/api/v1/";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
export const AI_BASE_URL = aiBaseUrl;
export const SITE_URL = siteUrl;
export const CLOUDFRONT_URL = cloudFrontUrl;
export const PFR_API_URL = pfrApiUrl;
